<div class="container-fluid p-0">
  <div class="row g-0">
    <div class="col-xl-3">
      <!--<div class="auth-full-bg pt-lg-5 p-4">
      <div class="w-100">-->
      <div class="bg-overlay" style="background: url(../../assets/Layout/images/Freelancer.jpg) no-repeat !important;"></div>

      <!--</div>
      </div>-->
    </div>
    <div id="LoadingImage">
      <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading Image" />
    </div>
    <div class="col-xl-9">
      <div class="auth-full-page-content p-3">
        <div class="w-100">
          <div class="d-flex flex-column h-100" id="flex">
            <div class="mb-4 mb-md-5">
              <div class="row g-0" style="text-align:center">
                <div class="col-xl-10 p-1">
                  <h1 style="color:darkblue">Freelancer Assignment Form</h1>
                  <p class="text-muted">Thank you for choosing us. Please enter your details for further communication.</p>
                </div>
                <div class="col-xl-2">
                  <a class="d-block auth-logo">
                    <img src="../../assets/Layout/images/NTLogo.png" alt="" height="60" class="auth-logo-dark">
                  </a>
                </div>

              </div>
              <div class="row g-0 col-12" style="height:60%;overflow-y:scroll;">
                <div class="container">
                  <div class="card" style="padding-left:3rem !important;padding-right:3rem !important;padding-top:1rem !important;padding-bottom:0rem !important; box-shadow:none !important">
                    <div class="card-body">
                      <div class="form-group">
                        <h5 style="background-color: #d3d3d340">Assignment Details!</h5>
                        <br />
                        <div class="row form-group">
                          <div class="col-sm-12" id="calendertable" style="text-align:center">
                            <!-- <p>Test Details</p><hr /><br />-->
                            <button type="button" id="btnPopupDT" class="btn btn-block btn-primary float-sm-right" (click)="getpopupFreelancerdate()" style="display:none"></button>
                            <button type="button" id="btnDownloadDT" class="btn btn-block btn-primary float-sm-right" (click)="testfiledownload()" style="display:none"></button>
                            <button type="button" id="btnUploadDT" class="btn btn-block btn-primary float-sm-right" (click)="TestFileUpload()" style="display:none"></button>
                            <table #dataTable class="display" style="width:100%" id="tblMainList"></table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card" style="padding-left:3rem !important;padding-right:3rem !important;padding-top:1rem !important;padding-bottom:0rem !important; box-shadow:none !important">
                    <div class="card-body">
                      <div class="form-group">
                        <h5 style="background-color: #d3d3d340">Unavailability Details!</h5>
                        <br />
                        <div class="row form-group">
                          <div class="col-sm-12" id="calendertable" style="text-align:center">
                            <!-- <p>UnAvailability Date </p><hr /><br />-->
                            <div class="row">
                              <div class="col-sm-6" style="text-align:left">
                                <div class="date-picker-header">
                                  <button class="btn btn-secondary" (click)="decrementMonth()">Prev</button> &nbsp;&nbsp;
                                  <button class="btn btn" id="month">{{ selectedYear }} {{ currentMonthName }}</button> &nbsp;&nbsp;
                                  <button class="btn btn-secondary " (click)="incrementMonth()">Next</button>
                                </div>


                              </div>
                              <div class="col-sm-6" style="text-align:right;">
                                <button type="button" class="btn btn-outline-success waves-effect waves-light" data-dismiss="modal" (click)="availability()">Add</button>&nbsp;
                                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" id="btnDeleteDT" (click)="DeleteUnavailabity()">Delete</button>
                                <button type="button" id="btnDeleteConfirm" (click)="DeleteConfirm()" style="display:none">Delete Confirm</button>

                              </div>

                            </div>
                            <br />
                            <table id="boxcalendar">
                              <thead>
                                <tr class="days">
                                  <th *ngFor="let day of ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']">{{ day }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let week of weeks">
                                  <td *ngFor="let day of week" [class.highlight]="isSelectedDate(day)" (click)="DeleteUnavailabity()" title="test" [min]="minDate" [max]="maxDate">
                                    <div class="d-flex">
                                      <div>{{ day || '' }}</div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table> &nbsp;
                            <!--<div class="row">
                              <div class="col">
                                <table id="boxcalendar1">
                                  <thead>
                                    <tr class="days">
                                      <th style="text-align:left">Links</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>Documents Links</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <br />
                              </div>
                            </div>-->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="divUploadData" class="modal" style="display:none">
                    <div class="modal-dialog modal-l ">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h4 class="modal-title">Upload Package</h4>
                          <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
                        </div>
                        <div class="modal-body" id="popupData">
                          <div class="col-sm-12" id="tblVendorMaster">
                            <div class="col-sm-12" id="testfileuploadbtn" style="padding: 20px;">

                              <input type="file" class="form-control" (change)="onuploadSelected($event)" id="doc_Defectuploadfile" />
                              File size must be 50MB<br /><br />
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnupload" (click)="confirmation()"><i class="fa fa-upload"></i> Upload</button>
                          <button id="testfileupload" (click)="testfileuploads()" style="display:none"></button>
                        </div>
                      </div>
                    </div>
                    <div id="LoadingImageReopen">
                      <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
                    </div>
                  </div>


                  <div class="modal " id="divAddAvailability">
                    <div class="modal-dialog modal-l ">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h4 class="modal-title">Choose Date </h4>
                          <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
                        </div>
                        <div class="modal-body" id="Availability">
                          <div class="row" id="chkAvailable">
                            <div class="col-sm-6">
                              <label>From Date</label><span class="required">*</span>
                              <input type="date" name="DOB" class="form-control float-right" id="Txt_From" autocomplete="off" (change)="GetDueDateValidation()" [min]="minDate" [max]="maxDate">
                            </div>
                            <div class="col-sm-6">
                              <label>To Date</label> <span class="required">*</span>
                              <input type="date" name="DOB" class="form-control float-right" id="Txt_To" autocomplete="off" (change)="GetDueDateValidation()" [min]="minDate" [max]="maxDate">
                            </div>
                          </div>
                          <br />
                          <div class="row">
                            <div class="col-sm-12">
                              <label>Remarks</label><span class="required">*</span>
                              <textarea class="form-control" id="TXT_Remarks" autocomplete="off"></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-outline-danger waves-effect waves-light" id="btnupload" (click)="hide()">Cancel</button>
                          <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="UpdateAvailabledetails()">Add</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="LoadingImage">
                    <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
                  </div>
                </div>
              </div>
              <div class="text-center">
                <p class="mb-0">
                  © 2024 Sesame by Novatechset
                </p>
              </div>
            </div>


          </div>
        </div>
      </div>

    </div>

  </div>



</div>


